import React, { useState, useContext, useEffect } from 'react';
import { MultiSelect } from "react-multi-select-component";
import * as pluralize from 'pluralize';
import { ConfigContext } from '../../shared/contexts/journeyConfig.context';

interface DriversSelectProps {
  options: Array<{
    label: string,
    value: number | number[],
  }>;
  selectedDrivers: Array<{
    label: string,
    value: number | number[],
  }>
  handleChange: (drivers) => void;
}

const DriversSelect = ({ options, selectedDrivers, handleChange}: DriversSelectProps) => {
  const [selected, setSelected] = useState(selectedDrivers);

  const labels = useContext(ConfigContext);
  const msg = `* If no ${pluralize(labels.agent).toLowerCase() || 'agents'} are selected, all will be shown.`

  useEffect(() => {
    setSelected(selectedDrivers);
  }, [selectedDrivers]);

  const onChange = (newValue) => {
    setSelected(newValue);
    handleChange(newValue);
  };

  return (
    <div className="d-flex align-items-center driversSelect flex-column">
      <MultiSelect
        options={options}
        value={selected}
        hasSelectAll
        onChange={onChange}
        labelledBy="Select"
      />
      <div className="driversSelect--msg">{msg}</div>
    </div>
  );
};

export default DriversSelect;
